import { useEffect, useRef, useState } from "react";

// Blendet Abschnitte beim Scrollen ein — einmalig, ohne Ruckeln
export function useScrollReveal(threshold = 0.15) {
  const ref = useRef(null);
  const [sichtbar, setSichtbar] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setSichtbar(true);
      return;
    }
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setSichtbar(true);
        obs.disconnect();
      }
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);

  return [ref, sichtbar];
}

export default useScrollReveal;
